
import { createAction, handleActions } from 'redux-actions';

const setShowUploadModal = createAction("SCREENS/PROJECT_VIEW/SET_SHOW_UPLOAD_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowUploadModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowUploadModal, reducer };